import { StyledMapsProps } from "./Maps.interface";
import styled from "styled-components";

export const StyledMap = styled.div<StyledMapsProps>`
  display: flex;
  height: 100%;
  min-height: ${({ minHeight }) => minHeight || '360px'};
  width: 100%;
`;